module.exports = __webpack_public_path__ + "static/media/different-equation-bg-2.e239f8a2.avif";